<template>
  <div>
    <div class="header py-7 py-lg-8 pt-lg-4"></div>
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <img style="width:200px; display:block; margin: 0 auto 2rem auto" :src="logo" class="navbar-brand-img" alt="RapidAIM" />
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <base-alert type="info">
                We have made some improvements to our security. In order to increase our security we need you to change your password.
              </base-alert>
              <base-alert type="info">
                Please check your email for the code.
              </base-alert>

              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(resetPassword)">
                  <base-input
                    alternative
                    class="mb-3"
                    name="code"
                    :rules="{ required: true, min: 6 }"
                    prepend-icon="fas fa-user"
                    placeholder="Code"
                    autocomplete="off"
                    v-model="model.code"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    name="newPassword"
                    validationName="newPassword"
                    :rules="{ required: true, min: 8, regex: /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/ }"
                    prepend-icon="fas fa-lock"
                    type="password"
                    placeholder="New Password"
                    autocomplete="new-password"
                    v-model="model.newPassword"
                  >
                  </base-input>
                  <base-input
                    alternative
                    class="mb-3"
                    name="confirmNewPassword"
                    validationName="password"
                    :rules="{ required: true, min: 8, confirmed: 'newPassword' }"
                    prepend-icon="fas fa-lock"
                    type="password"
                    placeholder="Confirm New Password"
                    autocomplete="new-password"
                    v-model="model.confirmNewPassword"
                    v-on:blur="passwordsMatch"
                  >
                  </base-input>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4">Reset password</base-button>
                  </div>
                </b-form>
              </validation-observer>
              <b-row class="mt-2 text-center">
                <b-col cols="12">
                  <router-link to="/login" class="text-dark"><small>Return to login</small></router-link>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseAlert from '@/components/BaseAlert';
import api from '@/api';

export default {
  components: {
    BaseAlert
  },
  props: {
    logo: {
      type: String,
      default: 'https://i2.wp.com/rapidaim.io/wp-content/uploads/2019/04/logo-horizontal-reversed-01-2x-contrast.png?fit=395%2C102&ssl=1',
      description: 'RapidAIM'
    },
  },
  data() {
    return {
      autocomplete: 'off',
      error: null,
      model: {
        code: '',
        newPassword: '',
        confirmNewPassword: ''
      },
      email: this.$route.params && this.$route.params.email
    };
  },
  methods: {
    resetPassword() {
      const { code, newPassword } = this.model;
      const loader = this.$loading.show();
      this.error = null;

      const setError = (error) => {
        loader.hide();
        this.error = error;
      }

      const navigateToLogin = () => {
        loader.hide();
        this.$router.push({name: "Login", params: { success: true }});
      }

      try {
        api.auth.confirmPassword({ verificationCode: code, newPassword, email: this.email, handleError: setError, handleNavigateToLogin: navigateToLogin });
      } catch (error) {
        loader.hide();
        this.error = error.message
      }
    },
    passwordsMatch: function() { 
      const passwordsMatch = this.newPassword === this.confirmNewPassword; 

      if (!passwordsMatch) {
        this.error = 'Passwords do not match.'
      }
    }
  }
};
</script>
